import axios from 'axios';

// Set base URL for all requests
axios.defaults.baseURL = process.env.REACT_APP_API_URL || 'https://api.pfaendungstabelle.voidmind.io';

// Add auth token to requests
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
    }
    return Promise.reject(error);
  }
);
